"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EuraTable = void 0;
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const EuraPage_1 = require("./EuraPage");
require("../styles/eura-table.css");
/**
 * Taulukko-komponentti, jolla esitetään taulukkomuotoista tietoa, esim. hakutuloksia.
 *
 * Wrapperi AntD:n Table-komponenttien ympärille: {@link https://ant.design/components/table/}
 *
 * @param props.titleType Näytetäänkö otsikkorivi taulukon sisällä, ulkona vai ei lainkaan
 * @param props.titleText Teksti otsikkoriville. Taulukon otsikon voi asettaa myös ATablen props.title:llä
 *
 * @example
 * ```
 * <EuraTable
 *   dataSource={[
 *     {
 *       key: '31a72a9f-aa2c-45fb-a754-7ec1bbc4b8ff',
 *       rahasto: 'EAKR',
 *       hakuilmoitus: 'Haku-4',
 *       viranomainen: 'Hämeen elinkeino-, liikenne- ja ympäristökeskus',
 *       voimassaolo: '29.03.2021–'
 *     },
 *     {
 *       key: '248724b1-cab4-41ef-acbd-2a61276f29f9',
 *       rahasto: 'ESR+',
 *       hakuilmoitus: 'Haku-2a61276f29f9',
 *       viranomainen: 'Etelä-Savon elinkeino-, liikenne- ja ympäristökeskus',
 *       voimassaolo: '29.03.2021–29.03.2024'
 *     },
 *     {
 *       key: '493de42b-f7a7-40d0-a10c-2653133cfed4',
 *       rahasto: 'EAKR',
 *       hakuilmoitus: 'EAKR Keski-Suomeen',
 *       viranomainen: 'Keski-Suomen elinkeino-, liikenne- ja ympäristökeskus',
 *       voimassaolo: '29.03.2021–04.04.2021'
 *     },
 *   ]}
 *   columns={[
 *     {
 *       title: 'Rahasto',
 *       dataIndex: 'rahasto',
 *     },
 *     {
 *       title: 'Hakuilmoitus',
 *       dataIndex: 'hakuilmoitus',
 *       sorter: (a, b) => a.hakuilmoitus.localeCompare(b.hakuilmoitus),
 *       ellipsis: true
 *     },
 *     {
 *       title: 'Viranomainen',
 *       dataIndex: 'viranomainen',
 *       sorter: (a, b) => a.viranomainen.localeCompare(b.viranomainen),
 *       ellipsis: true
 *     },
 *     {
 *       title: 'Voimassaolo',
 *       dataIndex: 'voimassaolo'
 *     },
 *   ]}
 *   onRow={(record, _rowIndex) => {
 *     return {
 *       onClick: (_event) => { console.log(record.key) }
 *     }
 *   }}
 *   pagination={{ position: ['bottomCenter'] }}
 *   titleText='Hakutulokset (3 kpl)'
 *   titleType='inside'
 * />
 * ```
 */
const EuraTable = (props) => {
    var _a;
    const { titleType = 'outside', titleText } = props, rest = __rest(props, ["titleType", "titleText"]);
    switch (titleType) {
        // Otsikko taulukon osana
        case 'inside':
            return react_1.default.createElement(Table, Object.assign({}, rest, { titleText: titleText }));
        // Otsikko taulukon ulkopuolella
        case 'outside':
            return (react_1.default.createElement("span", null,
                react_1.default.createElement(EuraPage_1.EuraPageRow, { title: titleText },
                    react_1.default.createElement(Table, Object.assign({}, rest)))));
        // Ei otsikkoa, ei reunusta taulukon ylälaidassa (BYO otsikkorivi)
        default:
            return react_1.default.createElement(Table, Object.assign({}, rest, { title: (_a = props.title) !== null && _a !== void 0 ? _a : undefined }));
    }
};
exports.EuraTable = EuraTable;
const Table = (props) => {
    const defaults = {
        pagination: { position: ['none', 'none'] },
        title: props.titleText ? () => props.titleText : props.title ? props.title : '',
        rowClassName: 'eura-table-row',
        size: 'large',
        showSorterTooltip: false,
        className: 'eura-table',
        tableLayout: 'fixed',
        showHeader: true,
        bordered: false,
        loading: false,
    };
    const options = Object.assign(Object.assign({}, defaults), props);
    return react_1.default.createElement(antd_1.Table, Object.assign({}, options));
};
exports.EuraTable.Table = Table;
